import { Breadcrumb, Upload, Typography, Modal, Row, Col, Button, DatePicker, Radio, Card, Input, Popconfirm, Checkbox, Switch } from 'antd';
import React, { useEffect, useState } from 'react';
import { Navigate, Outlet, useNavigate, useLocation } from 'react-router-dom'
import dayjs from 'dayjs';
import axios from 'axios';
import AdminModal from "./AdminModal";
import { ExclamationCircleFilled, PlusOutlined } from '@ant-design/icons';
const { Title, Paragraph, Text, Link } = Typography;
const { TextArea } = Input;
const { confirm } = Modal;
const ClassLessonModal = (props) => {
    return (
        <>
            <AdminModal
                {...props}
                title={(<>
                    <Col style={{ fontWeight: 'bold', fontSize: '20px', position: 'absolute', zIndex: 99, top: 53, left: 32 }} >{props.title}</Col>
                </>)}
                uploads
            >
                <Row gutter={[8, 8]} align={'middle'}>
                    <Col span={6}>班級名稱</Col>
                    <Col span={18}>
                        <Input placeholder={'請輸入班級名稱'}
                            value={props.editcard['name']}
                            onChange={e => props.setEditCard(prev => {
                                return (
                                    {
                                        ...prev,
                                        name: e.target.value,
                                    }
                                )
                            })}
                            autoComplete="off" />
                    </Col>
                    <Col span={6}>
                        班級內容
                    </Col>
                    <Col span={18}>
                        <TextArea rows={4} placeholder="請輸入班級內容"
                            value={props.editcard['content']}
                            onChange={e => props.setEditCard(prev => {
                                return (
                                    {
                                        ...prev,
                                        content: e.target.value,
                                    }
                                )
                            })}
                        />
                    </Col>
                    <Col span={6}>授課老師</Col>
                    <Col span={18}>
                        <label>{props.editcard['class_teachers']}</label>
                    </Col>
                    <Col span={6}>目前上課人數</Col>
                    <Col span={18}>
                        <label>{props.editcard['student_count']}人</label>
                    </Col>

                </Row>
            </AdminModal>
        </>
    )

}
export default ClassLessonModal; 